<template>
    <div class="font-serif antialiased  bg-main-black text-grey-lightest text-center font-semibold text-3xl">
        <div class="flex justify-center items-center w-full text-center">
            <div>
                <img src="./../assets/logo.svg" alt="Luyao Logo" class="h-16 rounded mr-6" />
            </div>
            <a href="/" class="no-underline text-white">Luyao</a>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped></style>